import React from 'react'
import { alpha, makeStyles } from '@material-ui/core/styles'
import { AppBar, Toolbar } from '@material-ui/core'
import { CourseToolBar, MainToolBar } from './components'
import clsx from 'clsx'
import { useLocation } from 'react-router-dom'

// ----------------------------------------------------------------------

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    backgroundColor: '#fff',
  },
  toolbar: {
    minHeight: 64,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 5),
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: 60,
    },
  },

  toolBarCourse: {
    minHeight: '0 !important',
    paddingTop: '10 !important',
    paddingBottom: '10 !important',
    paddingLeft: '16 !important',
    paddingRight: '0 !important',
  },
  borderBottom: {
    borderBottom: `1px solid #F4F6F8`,
  },
}))

const TopBar = props => {
  const { className } = props
  const classes = useStyles()
  const location = useLocation()
  const pathSegments = location.pathname.split('/')
  const subPage = pathSegments[pathSegments.length - 1]

  const isMiniCoursePage =
    window.location.pathname.includes('mini-course') &&
    !window.location.pathname.includes('mini-courses')

  return (
    <AppBar
      className={clsx(classes.root, className, {
        [classes.borderBottom]: isMiniCoursePage,
      })}
    >
      <Toolbar
        className={clsx({
          [classes.toolbar]: !isMiniCoursePage,
          [classes.toolBarCourse]: isMiniCoursePage,
        })}
      >
        {isMiniCoursePage ? (
          <>{subPage !== 'editor' && <CourseToolBar />}</>
        ) : (
          <MainToolBar />
        )}
      </Toolbar>
    </AppBar>
  )
}

export default TopBar
